<template lang="pug">
  .inicio-main-dash-insurances
    .inicio-panel.list-insurances.panel-full-height.mt-2.border-radius-top(xs12 sm12)
      h2.title-main
        | Mis seguros
        //- v-btn(@click="$router.push('/inicio')")
          img(:src="arrowBack" width="12%")
          | Atrás
      p.text-instruction(v-if="!loading") Elige el seguro que deseas ver
      v-layout(v-if="loading" row wrap)
        v-flex#loader(xs12 sm12 md12 lg12)
          p CARGANDO PÓLIZAS
          pulse-loader(:loading="loading" :color="color" :size="size")
      v-layout(v-if="!loading && polizasInfoClone.length < 1" row wrap)
        v-flex#loader(xs12 sm12 md12 lg12)
          p NO TIENES PÓLIZAS VIGENTES
      div.list-container(v-if="!loading")
        v-card.wrapper(v-for="(poliza, index) in polizasInfoClone" :key="poliza.numeroPoliza" v-if="index%2==0")
          list-insurance-policy(:poliza="poliza")
          list-insurance-policy(:poliza="polizasInfoClone[index+1]")
    .inicio-extra
      section
        figure.d-flex.align-center.justify-center(style="margin-top:40px; ")
          img(src="../assets/insurances/extra-mis-seguros.svg")
    // DETAILS
    v-dialog(v-model="showAnnuity" fullscreen hide-overlay persistent transition='dialog-bottom-transition')
      v-card(v-if="showAnnuity")
        v-toolbar#toolbar.header-info-policy(dark color="primary")
          v-btn.btn-backspace(outline flat fab small @click="closeModal('rentas')")
            v-icon keyboard_backspace
          v-toolbar-title
            h3
              | {{ annuity.producto }}
        v-card-text#annuity-content
          v-container(v-bind:class="{ 'grid-list-md': $vuetify.breakpoint.mdAndUp }")
            form-annuity(:annuity="annuity")
    v-dialog(v-model="showGuaranteed" fullscreen hide-overlay persistent transition='dialog-bottom-transition')
      v-card(v-if="showGuaranteed")
        v-toolbar#toolbar.header-info-policy(dark color='primary')
          v-btn.btn-backspace(outline flat fab small @click="closeModal('vida')")
            v-icon keyboard_backspace
          v-toolbar-title
            h3
              | {{ guaranteed.producto }}
        v-card-text#guaranteed
          v-container(v-bind:class="{ 'grid-list-md': $vuetify.breakpoint.mdAndUp }")
            form-guaranteed-education(:guaranteed="guaranteed")
    v-dialog(v-model="showMasivo" fullscreen hide-overlay persistent transition='dialog-bottom-transition')
      v-card(v-if="showMasivo")
        v-toolbar#toolbar.header-info-policy(dark color='primary')
          v-btn.btn-backspace(outline flat fab small @click="closeModal('masivo')")
            v-icon keyboard_backspace
          v-toolbar-title
            h3
              | {{ masivo.producto }}
        v-card-text#guaranteed
          v-container(v-bind:class="{ 'grid-list-md': $vuetify.breakpoint.mdAndUp }")
            form-masivo(:guaranteed="masivo")
</template>

<script>
import ListInsurancePolicy from '@/components/ListInsurancePolicy'
import FormAnnuity from '@/components/FormAnnuity'
import FormMasivo from '@/components/FormMasivo'
import FormGuaranteedEducation from '@/components/FormGuaranteedEducation'
// import FormGuaranteedEducationPersonal from '@/components/FormGuaranteedEducationPersonal'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      polizasInfoClone: [],
      // RENTAS
      showAnnuity: false,
      showPersonalAnnuity: false,
      // VIDA
      showGuaranteed: false,
      showPersonalGuaranteed: false,
      showMasivo: false,
      annuity: null,
      guaranteed: null,
      masivo: null,
      loading: true,
      color: '#3FA6F2',
      size: '11px',
      arrowBack: require('./../assets/icons/arrow-back.svg')
    }
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'userInfo'])
  },
  methods: {
    ...mapActions('user', ['getPolizas']),
    closeModal (type) {
      // HIDE SUB-NAV
      this.$root.$emit('hideSubNav', {})
      // CLOSE TYPE MODAL
      switch (type) {
      case 'vida':
        // REMOVE FIX WHEN DIALOG DISAPPEAR
        document.body.removeAttribute('class', 'noscroll')
        // REMOVE MIN-HEIGHT 100vh WHEN DIALOG DISAPPEAR
        document.querySelector('#app.protected .application--wrap').removeAttribute('style')
        this.showGuaranteed = false
        break
      case 'rentas':
        // REMOVE FIX WHEN DIALOG DISAPPEAR
        document.body.removeAttribute('class', 'noscroll')
        // REMOVE MIN-HEIGHT 100vh WHEN DIALOG DISAPPEAR
        document.querySelector('#app.protected .application--wrap').removeAttribute('style')
        this.showAnnuity = false
        break
      case 'masivo':
        // REMOVE FIX WHEN DIALOG DISAPPEAR
        document.body.removeAttribute('class', 'noscroll')
        // REMOVE MIN-HEIGHT 100vh WHEN DIALOG DISAPPEAR
        document.querySelector('#app.protected .application--wrap').removeAttribute('style')
        this.showMasivo = false
        break
      }
    },
    logout (evt) {
      evt.preventDefault()
      if (localStorage.removeItem('jwt') !== null) {
        this.$store.state.user.session = null
        this.$store.state.user.jwt = null
        this.$store.state.user.coUs = null
        this.$store.state.user.info = null
        this.$store.state.user.user = null
        this.$store.state.user.polizas = null
        this.$store.state.user.historyPayments = null
        localStorage.removeItem('products')
        this.$router.push('/')
      }
    },
    logoutWithOutPolicies () {
      const self = this
      self.$swal({
        title: '¡Sin productos disponibles para tu Zona Segura!',
        text: 'Estamos trabajando para que puedas realizar más operaciones. Pronto te enterarás de más novedades.',
        confirmButtonText: 'Entendido'
      }).then(() => {
        self.$store.commit('user/setSearch', '')
        // CLEAR ALL INTERVALS
        clearInterval(self.interval)
        self.loader = true
        // FOR CLIENTS RPP/IFP
        if (localStorage.removeItem('jwt') !== null) {
          self.$store.state.user.haveLoanRequested = null
          self.$store.state.user.session = null
          self.$store.state.user.jwt = null
          self.$store.state.user.coUs = null
          self.$store.state.user.info = null
          self.$store.state.user.user = null
          self.$store.state.user.polizas = null
          self.$store.state.user.historyPayments = null
          self.$store.state.user.exp = null
          self.$store.state.user.names = null
          localStorage.removeItem('products')
          self.$router.push('/')
        }
      })
    },
    consultaPolizas () {
      const self = this
      setTimeout(() => {
        self.getPolizas(self.userInfo).then((res) => {
          let polizasInput = res.data.polizas.filter(x => !(x.canal && x.canal.toUpperCase() === 'FALABELLA') && !x.producto.toLowerCase().includes('viajes'))
          if (polizasInput.length < 1) {
            self.logoutWithOutPolicies()
          } else {
            self.polizasInfoClone = res.data.polizas
          }
          self.loading = false
        })
      }, 5000)
    }
  },
  created: function () {
    var self = this
    this.$root.$on('displayGuaranteed', function (obj) {
      self.showGuaranteed = true
      self.guaranteed = obj
      // WHEN IS MEDIUM/LARGE DESKTOP
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.$vuetify.goTo('.application--wrap', {})
      } else {
        // WHEN IS MEDIUM/SMALL DESKTOP
        // Class for remove scroll of behind dives when dialog appear (issue iOS scrolling)
        document.querySelector('#app.protected .application--wrap').style.minHeight = '100vh'
        document.body.className = 'noscroll'
      }
    })
    this.$root.$on('hideGuaranteed', function (obj) { self.showGuaranteed = false })
    this.$root.$on('displayAnnuity', function (obj) {
      self.showAnnuity = true
      self.annuity = obj
      // WHEN IS MEDIUM/LARGE DESKTOP
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.$vuetify.goTo('.application--wrap', {})
      } else {
        // WHEN IS MEDIUM/SMALL DESKTOP
        // Class for remove scroll of behind dives when dialog appear (issue iOS scrolling)
        document.querySelector('#app.protected .application--wrap').style.minHeight = '100vh'
        document.body.className = 'noscroll'
      }
    })
    this.$root.$on('hideAnnuity', function (obj) { self.showAnnuity = false })
    this.$root.$on('displayMasivo', function (obj) {
      self.showMasivo = true
      self.masivo = obj
      // WHEN IS MEDIUM/LARGE DESKTOP
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.$vuetify.goTo('.application--wrap', {})
      } else {
        // WHEN IS MEDIUM/SMALL DESKTOP
        // Class for remove scroll of behind dives when dialog appear (issue iOS scrolling)
        document.querySelector('#app.protected .application--wrap').style.minHeight = '100vh'
        document.body.className = 'noscroll'
      }
    })
    this.$root.$on('hideMasivo', function (obj) { self.showMasivo = false })
    this.$root.$on('donePolizas', function (obj) {
      self.loading = !self.loading
    })
    // DISPLAY PERSONAL DATA POLICY FROM PROTECTED LAYOUT
    this.$root.$on('displayInfoPolicy', function (obj) {
      switch (obj.ramo) {
      case 'vida':
        self.showGuaranteed = true
        if (obj.what === 'info') {
          self.showPersonalGuaranteed = false
        } else if (obj.what === 'personal') {
          self.showPersonalGuaranteed = true
        }
        break
      case 'rentas':
        self.showAnnuity = true
        if (obj.what === 'info') {
          self.showPersonalAnnuity = false
        } else if (obj.what === 'personal') {
          self.showPersonalAnnuity = true
        }
        break
      case 'masivo':
        self.showMasivo = true
        if (obj.what === 'info') {
          self.showPersonalMasivo = false
        } else if (obj.what === 'personal') {
          self.showPersonalMasivo = true
        }
        break
      }
    })
  },
  mounted () {
    const self = this

    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros'})

    if (this.polizasInfo !== null) {
      this.polizasInfoClone = this.polizasInfo
      this.loading = false
    } else {
      this.consultaPolizas()
    }
  },
  components: {
    'list-insurance-policy': ListInsurancePolicy,
    'form-annuity': FormAnnuity,
    'form-masivo': FormMasivo,
    'form-guaranteed-education': FormGuaranteedEducation,
    // 'form-guaranteed-education-personal': FormGuaranteedEducationPersonal,
    PulseLoader
  }
}
</script>

<style>
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  /** HEADER POLICY */
  .header-info-policy button.btn-backspace, .header-info-policy h3 { display: inline-block; }
  .header-info-policy button.btn-backspace {
    border: 2px solid;
    margin-left: 0;
    height: 34px;
    width: 34px;
  }
  .header-info-policy button.btn-backspace .v-btn__content i {
    font-size: 25px;
    position: relative;
    right: 1.5px;
  }
  /** HEADER POLICY */
  /** NEW STYLE 3 */
  .header-guaranteed-close-session {
    display: flex;
    align-items: center;
  }
  /** NEW STYLE 3 */
  .insurances {
    background-color: transparent;
    padding: 0 1em;
  }
  .insurances .wrapper {
    margin-bottom: 1em;
    box-shadow: none;
    border-radius: initial;
    background-color: #F6F6F6;
  }
  #loader {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    margin-top: 3rem;
  }
  #loader p, #loader div {
    display: inline-block;
    margin: 0;
  }
  #loader p {
    color: var(--text-color);
    font-family: 'Omnes Regular';
    font-size: 18px;
  }
  #loader div {
    position: relative;
    top: 2px;
  }
  .insurances { background-color: #F6F6F6; }
  .title-insurances h1 {
    color: #7C7C7C;
    font-family: 'Omnes Regular';
    font-size: 24px;
  }
  .v-dialog .v-card nav.v-toolbar { box-shadow: none; }
  .v-dialog.v-dialog--persistent.v-dialog--fullscreen { -webkit-overflow-scrolling: touch; }
  /* PANE COLLAPSE   */
  ul.v-expansion-panel.theme--light { box-shadow: none; }
  ul.v-expansion-panel.theme--light li.v-expansion-panel__container {
    border: 0;
    margin-bottom: 10px;
  }
  ul.v-expansion-panel.theme--light li.v-expansion-panel__container .v-expansion-panel__header {
    color: var(--second-brand-color);
    font-size: 19px;
    background-color: #EFF1F4;
    border-radius: 22px;
  }
  ul.v-expansion-panel.theme--light li.v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon i {
    background-color: #00AAFF;
    color: #FFF !important;
    border-radius: 13px;
  }
  /* Dialog for Annuity */
  #toolbar .v-toolbar__content {
    background-color: #0855C4;
  }
  #toolbar .v-toolbar__content .v-toolbar__items button .v-btn__content i {
    font-size: 37px;
    font-weight: bold;
  }
  /* Dialog for Guaranteed */
  #toolbar .v-toolbar__content .v-toolbar__title h3 {
    font-family: 'Omnes Medium';
    font-weight: normal;
    text-align: left;
    font-size: 22px;
    width: 100%;
    color: #FFF;
  }
  #toolbar .v-toolbar__content .v-toolbar__title p {
    font-family: 'Omnes Regular';
    text-align: left;
    font-size: 15px;
    color: #FFF;
  }
  .polizas .flex:first-child {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .polizas .flex.detail {
    display: flex;
    align-items: flex-end;
  }
  .insurances .wrapper .first { margin-bottom: 1em; }
  #payment_receipts h3, h2#title-download {
    margin: .5rem 0;
    font-size: 23px;
    font-weight: normal;
    padding-left: 1em;
  }
  .header-annuity-close-session {
    padding-top: 21px;
    padding-right: 58px;
  }
  .second-info button { width: auto; }
  /* TITLE OF DIALOGS */
  #toolbar .v-toolbar__content .v-toolbar__title {
    margin-left: 3px;
  }

  .inicio-main-dash-insurances .inicio-extra {
    display: none;
  }

  .inicio-panel.list-insurances {
    border: 0;
  }

  .inicio-panel.list-insurances .text-instruction {
    margin-bottom: 30px;
    animation: fade-in .2s ease-in forwards;
  }

  .inicio-panel.list-insurances .list-container {
    animation: fade-in .2s ease-in forwards;
  }

  /* Small to large handset ----------- */
  @media only screen and (max-width : 600px) {
    /** NEW STYLE FOR RENTAS */
    #toolbar .v-toolbar__content .v-toolbar__title h3 {
      padding-left: 5px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    #annuity-content h2 {
      font-size: 22px;
      font-weight: normal;
      margin-top: 1em;
    }
    #annuity p, #proof_retirement p {
      float: left;
      margin-top: 7px;
      padding-left: 10px;
      font-family: 'Omnes Regular';
      color: #414141;
    }
    #annuity, #proof_retirement {
      background-color: #F7F7F7;
      border-radius: 9px;
      padding: 10px 4px;
      margin-bottom: 1.4em;
    }
    #annuity button, #proof_retirement button {
      float: right;
      padding-right: 10px;
    }
    #payment_receipts h3 {
      margin-top: 0 !important;
      padding: 0;
      margin-bottom: 0 !important;
      font-family: 'Omnes Medium';
      color: #414141 !important;
      font-size: 20px;
      padding-left: 10px;
    }
    .inicio-panel.list-insurances {
      padding-top: 0;
      margin: 0 20px;
      padding: 20px 0;
    }
  }
  /* Large tablet to laptop ----------- */
  @media only screen  and (min-width : 961px) and (max-width: 1264px) {
  /* Styles */
  }

  @media only screen and (min-width : 1024px) {
    .inicio-main-dash-insurances {
      width: 100%;
      display: flex;
    }
    .inicio-main-dash .inicio-main-dash-insurances .inicio-extra {
      display: inline-block;
      width: 350px;
      padding: 0 50px;
    }
    .inicio-main-dash-insurances .inicio-panel.list-insurances {
      padding: 25px 50px;
      min-width: 880px;
      margin-right: 10px;
      margin-left: 10px;
    }

  }

  /* Desktop ----------- */
  @media only screen  and (min-width : 1265px) {
    /** BTN CLOSE FOR MODAL INSURANCE */
    .main-title-personal .second-info button, .main-product-title .second-info button { font-size: 20px; }
    .main-title-personal .second-info button .v-btn__content i, .main-product-title .second-info button .v-btn__content i {
      font-size: 27px;
      position: relative;
      right: 5px;
    }
    /** BTN CLOSE FOR MODAL INSURANCE */
    .wrapper.v-card {
      box-shadow: none;
      border-radius: 0;
      margin: 0 15% 0 9%;
    }
    #loader { margin-top: 5em; }
    .insurances {
      position: initial;
      padding: 0;
    }
    .title-insurances {
      background-color: transparent;
      height: auto;
      min-height: auto;
    }
    .title-insurances h1 {
      color: #1361B9;
      padding-top: 0;
      text-align: left;
      border-bottom: 1.4px solid;
      padding-bottom: 5px;
      margin-bottom: 1.4em;
    }
    #toolbar .v-toolbar__content {
      max-width: 1185px;
      margin: auto;
      padding: 0 17px;
    }
    #toolbar .v-toolbar__content .v-toolbar__title h3 {
      font-family: 'Omnes Medium';
      font-weight: normal;
    }
    p.v-subtitle {
      background-color: #FFF;
      color: var(--second-brand-color);
      padding-left: 9.7%;
      padding-top: 2em;
      padding-bottom: 1em;
      margin: 0;
      display: flex;
      align-items: center;
    }
    p.v-subtitle img {
      width: 3%;
      margin-right: 10px;
    }
    /* FORMS OF POLIZAS */
    .container-info-poliza {
      border: 1px solid #707070;
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 7px;
    }
    p.subtitle-polizas {
      font-size: 17px;
      font-weight: normal;
    }
    .form-input-group .v-input__control .v-input__slot {
      background-color: #EFF1F4;
      border: #EFF1F4 1px solid;
      border-radius: 20px;
      padding: 3px 12px;
      margin-bottom: 0;
    }
    #toolbar .v-toolbar__content .v-toolbar__items button .v-btn__content i {
      color: var(--second-brand-color);
    }
    #toolbar .v-toolbar__content .v-toolbar__items button .v-btn__content {
      background-color: #FFF;
      border-radius: 18px;
    }
    /* REMOVE BORDER BOTTOM WHEN CLICK INPUT */
    .form-input-group .v-input__control .v-input__slot:before, .form-input-group .v-input__control .v-input__slot:after { width: 0; }
    .form-input-group .v-input__control .v-input__slot .v-text-field__slot input {
      font-family: 'Omnes Regular';
      font-size: 13px;
    }
    .form-input-group .v-input__control .v-input__slot .v-text-field__slot label {
      color: #535D66;
      font-size: 20px;
      top: -7px;
      left: -8px !important;
      font-family: 'Omnes Medium'
    }
    .form-input-group .v-input__control .v-input__slot:before { border: none }
    .form-input-group.date-input-group .v-input__control .v-input__slot { margin-top: 12px }
    .form-input-group.date-input-group .v-input__control .v-input__slot label {
      font-size: 23px;
      height: 24px;
      font-weight: normal;
      font-family: 'Omnes Regular';
      top: -12px;
      padding-top: 1px;
    }
    #btnDownloadEstado.v-btn.v-btn--disabled {
      background-color: rgba(0,0,0,.12)!important;
    }
    .v-btn.download-btn-files, #btnDownloadEstado {
      background-color: var(--fuchsia-color) !important;
      color: #fff;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      /* border-radius: 5px; */
      border-radius: 3px;
      height: auto;
      /* width: 100%; */
      width: 80%;
      margin: 0;
      text-transform: none;
      padding: 14px 0;
      min-height: 46px;
      height: 46px;
    }
    .v-dialog.v-dialog--fullscreen .v-card.theme--light nav#toolbar {
      position: fixed;
      z-index: 9;
      background-color: #0855C4 !important;
    }
    .v-dialog.v-dialog--fullscreen .v-card.theme--light #guaranteed, .v-dialog.v-dialog--fullscreen .v-card.theme--light  #annuity-content { padding-top: 93px; }
  }
  @media screen and (min-width: 1400px) {
    p.v-subtitle { padding-left: 9em; }
    .container.grid-list-md {
      padding-left: 0;
      padding-right: 0;
    }
    main.v-content .v-content__wrap .layout.header {
      padding-top: .7em;
      padding-bottom: .6em;
    }
  }
  @media only screen  and (min-width : 1500px) {
    #toolbar .v-toolbar__content {
      max-width: 1815px;
      margin: auto;
      padding: 0 17px;
    }
  }
  /* ----------- Galaxy Phones ----------- */
  /* Portrait and Landscape */
  @media screen and (-webkit-min-device-pixel-ratio: 3) and (min-resolution: 192dpi) and (max-width: 640px) {
  }
  /* iPhone X in portrait & landscape ----------- */
  @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-device-pixel-ratio: 3) {
  }
  /* iPhone XR in portrait & landscape ----------- */
  @media only screen and (device-width : 414px) and (device-height : 896px) and (-webkit-device-pixel-ratio : 2) {
  }
</style>



// WEBPACK FOOTER //
// src/pages/MyInsurance.vue